import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData } from '../../apiService';
import { Card, CardContent, Button } from '@mui/material';
import Refresh from '@mui/icons-material/Refresh';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CachedIcon from '@mui/icons-material/Cached';
import AssessmentIcon from '@mui/icons-material/Assessment';
import InventoryIcon from '@mui/icons-material/Inventory';
import { useAuth } from '../../AuthContext';
import { tokenIsExpired } from '../../authUtils';
import Select from 'react-select';
import './Home.css'; // Import your CSS file
import './HomeEnhanced.css'; // Import enhanced styling
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CopyrightIcon from '@mui/icons-material/Copyright';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import BuildIcon from '@mui/icons-material/Build';
import {
  Delete as DeleteIcon, Edit as EditIcon, ArrowForward,
  CheckCircle as ActivateIcon, Search as SearchIcon,
  Print as PrintIcon, Info as InfoIcon
} from '@mui/icons-material';
import AsyncSelect from 'react-select/async';

import {
  IconButton
} from '@mui/material';

const Home = () => {
  const { isAuthenticated, companyId, branchId, permissions, token, logout, roleName } = useAuth();
  const { id } = useParams();
  const history = useHistory();
  const [stockData, setStockData] = useState([]);
  const [penstockData, setPenStockData] = useState([]);
  const [penstockPendingData, setPenStockPendingData] = useState([]);
  const [itemId, setItem] = useState('');
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [showTable, setShowTable] = useState(false);


  const handleStockCheck = () => {
    setShowTable(!showTable);
    setStockData([]); // Clear stockData    
    setSelectedItems(null); // Reset selectedItems
    setSelectedOption(null); // Clear AsyncSelect
    fetchOptions('');
  };


  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }
  }, [isAuthenticated, companyId, branchId, token, logout, id]);

  // Items    
  const [itemsOptions, setItemsOptions] = useState([]);
  const [selectedItems, setSelectedItems] = useState("");

  useEffect(() => {
    //fetchItems();
  }, []);

  const fetchOptions = async (inputValue) => {
    if (inputValue.length <= 4) {
      return [];
    }

    const response = await fetchData('PurchaseApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);
    if (response.responseCode === '1111') {
      const data = await response.response_data;
      return data.map(item => ({
        value: item.Id,
        label: item.Code + '-' + item.Name,
      }));
    }
  };



  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const response = await fetchData('ReportApi', `/Stockin/${companyId}/${branchId}`, token);
        if (response.responseCode === '1111') {
          setPenStockData(response.response_data);
        }
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };

    fetchStockData();
  }, [companyId, branchId, token]);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const response = await fetchData('ReportApi', `/Stockinpend/${companyId}/${branchId}`, token);
        if (response.responseCode === '1111') {
          setPenStockPendingData(response.response_data);
        }
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };

    fetchStockData();
  }, [companyId, branchId, token]);



  const fetchItems = async () => {
    try {
      const response = await fetchData('ReportApi', `/Item/${companyId}/${branchId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(item => ({
          value: item.Id,
          label: item.Code + '-' + item.Name
        }));
        setItemsOptions(options);
      }
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const handleItemSelect = (selectedOption) => {
    setSelectedItems(selectedOption);
    const itId = selectedOption ? selectedOption.value : '';
    setItem(itId);
  };

  const handleChangeDrop = (selectedOption) => {
    setSelectedOption(selectedOption);
    const itId = selectedOption ? selectedOption.value : '';
    setItem(itId);
  };


  const handleRefresh = async () => {
    try {
      if (!itemId) {
        setError("Please select an item.");
        return;
      } else {
        const response = await fetchData('ReportApi', `/BranchStock/${companyId}/${itemId}`, token);
        if (response.responseCode === '1111') {
          const stockData = response.response_data;
          setStockData(stockData);

          // Calculate total quantity
          const total = stockData.reduce((sum, invdetail) => sum + invdetail.ClosingQty, 0);
          setTotalQuantity(total);
        }
      }
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  };

  function formatDate(dateString) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
    return formattedDate;
  }

  const [selectedOption, setSelectedOption] = useState(null);
  const handleInputChange = (newValue) => newValue;
  const allowedBranchIds = [2, 1004, 1010];

  return (
    <div className="home-container container w-full max-w-sm mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto' }}>
      <style>
        {`
        /* Hide scrollbar for Chrome, Safari, and Opera */
        .container::-webkit-scrollbar {
          width: 0.1em;
        }

        .container::-webkit-scrollbar-track {
          background: rgba(255,255,255,0);
        }

        .container::-webkit-scrollbar-thumb {
          background-color: rgba(255,255,255,0);
          border-radius: 4px;
        }
      `}
      </style>
      <div className="flex flex-wrap justify-between">

        <div className="w-full sm:w-4/4 mb-4 ">
          <CardContent className="home-card-content">
            <div className="flex justify-between items-center">
              <h4 className="block uppercase text-lg font-semibold mb-4 home-linkcolor home-animated-title" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}></h4>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                {/* Stock Check Button */}
                <Button
                  className="home-button bg-teal-600 text-white px-3 py-1 rounded-md text-sm hover:bg-teal-700"
                  onClick={handleStockCheck}
                  style={{ background: 'linear-gradient(to right, darkslateblue, slategray)', color: 'white', height: '26px', marginRight: '8px' }}
                >
                  <VisibilityIcon style={{ fontSize: '15px', marginRight: '5px' }} /> Stock Check
                </Button>

                {/* Role-Based Buttons */}
                {roleName !== "Accounts" && (
                  <>
                    <Button
                      className="home-button bg-blue-600 text-white px-3 py-1 rounded-md text-sm hover:bg-blue-700"
                      component={Link}
                      to="/SaleCreate"
                      style={{ background: 'linear-gradient(to right, darkslategray, slategray)', color: 'white', height: '26px', marginRight: '8px' }}
                    >
                      <ShoppingCartIcon style={{ fontSize: '15px', marginRight: '5px' }} />Sale
                    </Button>
                    <Button
                      className="home-button bg-orange-600 text-white px-3 py-1 rounded-md text-sm hover:bg-orange-700"
                      component={Link}
                      to="/RepairAndReplacementCreate"
                      style={{ background: 'linear-gradient(to right, #1CAC78, slategray)', color: 'white', height: '26px', marginRight: '8px' }}
                    >
                      <BuildIcon style={{ fontSize: '15px', marginRight: '5px' }} /> Repair / Replacement Receipt
                    </Button>

                    <Button
                      className="home-button bg-red-600 text-white px-3 py-1 rounded-md text-sm hover:bg-red-700"
                      component={Link}
                      to="/PurchaseCreate"
                      style={{ background: 'linear-gradient(to right, blueviolet, slategray)', color: 'white', height: '26px', marginRight: '8px' }}
                    >
                      <AddShoppingCartIcon style={{ fontSize: '15px', marginRight: '5px' }} /> Purchase
                    </Button>

                    <Button
                      className="home-button bg-purple-600 text-white px-3 py-1 rounded-md text-sm hover:bg-purple-700"
                      component={Link}
                      to="/StockTransferCreate"
                      style={{ background: 'linear-gradient(to right, darkcyan, slategray)', color: 'white', height: '26px', marginRight: '8px' }}
                    >
                      <ExitToAppIcon style={{ fontSize: '15px', marginRight: '5px' }} /> Stock Out
                    </Button>

                    <Button
                      className="home-button bg-purple-600 text-white px-3 py-1 rounded-md text-sm hover:bg-purple-700"
                      component={Link}
                      to="/StockInCreate"
                      style={{ background: 'linear-gradient(to right, darkcyan, slategray)', color: 'white', height: '26px', marginRight: '8px' }}
                    >
                      <ExitToAppIcon style={{ fontSize: '15px', marginRight: '5px' }} /> Stock In
                    </Button>


                    <Button
                      className="home-button bg-yellow-600 text-white px-3 py-1 rounded-md text-sm hover:bg-yellow-700"
                      component={Link}
                      to="/Stock"
                      style={{ background: 'linear-gradient(to right, darkorange, slategray)', color: 'white', height: '26px', marginRight: '8px' }}
                    >
                      <InventoryIcon style={{ fontSize: '15px', marginRight: '5px' }} />Stock
                    </Button>

                    <Button
                      className="home-button bg-gray-600 text-white px-3 py-1 rounded-md text-sm hover:bg-gray-700"
                      component={Link}
                      to="/DailySalesSummary"
                      style={{ background: 'linear-gradient(to right, brown, slategray)', color: 'white', height: '26px', marginRight: '8px' }}
                    >
                      <AssessmentIcon style={{ fontSize: '15px', marginRight: '5px' }} /> DSS
                    </Button>
                  </>
                )}
              </div>

            </div>

            {showTable && (
              <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div className="w-full mb-4 flex">
                  <div className="w-3/7 mr-3 home-select" style={{ marginLeft: '5px', width: '500px' }}>
                    <label className="home-label block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                      Item Name
                      <span className="text-red-500">*</span>
                    </label>
                    {/* <Select
                      value={selectedItems}
                      onChange={handleItemSelect}
                      options={itemsOptions}
                      placeholder="Items"
                      isSearchable
                    /> */}

                    <AsyncSelect
                      cacheOptions
                      loadOptions={fetchOptions}
                      onInputChange={handleInputChange}
                      onChange={handleChangeDrop}
                      value={selectedOption}
                      menuPortalTarget={document.body}   // ⭐ Makes dropdown appear outside container
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderRadius: '10px',
                          borderColor: state.isFocused ? '#667eea' : '#e5e7eb',
                          boxShadow: state.isFocused ? '0 0 0 2px rgba(102, 126, 234, 0.1)' : 'none',
                          '&:hover': { borderColor: '#667eea' },
                          minHeight: '32px',
                          height: '32px',
                          fontSize: '12.5px',
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,  // ⭐ ensures dropdown appears above all elements
                        }),
                        menu: (base) => ({
                          ...base,
                          fontSize: '12px',
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: '12px',
                          padding: '6px 10px',
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: '12px',
                        }),
                      }}
                    />
                  </div>
                  <div className="w-1/2 mr-4">
                    <Button onClick={handleRefresh} startIcon={<Refresh style={{ color: 'brown' }} />} style={{ marginTop: '25px', marginLeft: '12px', color: 'brown', fontWeight: 'bolder' }}>REFRESH</Button>
                  </div>
                </div>

                <div className="w-full mb-2 flex">

                  <TableContainer component={Paper} className="home-table-container">
                    <Table>
                      <TableHead className="home-table-head" sx={{ backgroundColor: '#008080' }}>
                        <TableRow>
                          <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke' }}>BRANCH NAME</TableCell>
                          <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', textAlign: 'right' }}>QUANTITY</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="home-table-body" style={{ backgroundColor: '#9BC1B3' }}>

                        {stockData.map((item, index) => (
                          <TableRow
                            className="home-table-row home-highlighted-row"
                            sx={{
                              padding: '5px',
                              height: '30px',

                              backgroundColor: 'transparent',

                            }}
                          >
                            <TableCell className="home-table-cell" sx={{ height: '30px', borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', width: '75%' }}>{item.BranchName}</TableCell>
                            <TableCell className="home-table-cell" sx={{ height: '30px', borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{item.ClosingQty.toFixed(2)}</TableCell>
                          </TableRow>
                        ))}

                        <TableRow
                          className="home-table-row home-total-row"
                          sx={{
                            padding: '7px',
                            height: '30px',
                            backgroundColor: '#507687 !important',
                          }}
                        >
                          <TableCell className="home-table-cell" sx={{ height: '30px', borderBottom: '1px solid #F5F5F5', color: 'white !important', fontWeight: 'bolder', padding: '5px', textAlign: 'Left', fontSize: '12px' }}>Total</TableCell>
                          <TableCell className="home-table-cell" sx={{ height: '30px', borderBottom: '1px solid #F5F5F5', color: 'white !important', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalQuantity.toFixed(2)}</TableCell>
                        </TableRow>
                      </TableBody>


                    </Table>
                  </TableContainer>
                </div>
              </div>
            )}

          </CardContent>
        </div>

        {roleName != "Accounts" && (
          <div className="w-full sm:w-4/4 mb-4 ">
            <CardContent className="home-card-content">
              <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black home-productHead flex-grow home-linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>CONFIRM STOCK TRANSFER IN</h6>
              </div>

              <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper} className="home-table-container">
                  <Table className="home-table">
                    <TableHead className="home-table-head" sx={{ backgroundColor: '#008080' }}>
                      <TableRow>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '10%' }}>BILL DATE</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '10%' }}>BILL NUMBER</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '40%' }}>FROM BRANCH</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '10%', textAlign: 'center' }}>AMOUNT</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '10%', textAlign: 'center' }}>QUANTITY</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', textAlign: 'center' }}>ACTIONS</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="home-table-body" style={{ backgroundColor: '#9BC1B3' }}>
                      {penstockData.map(item => (
                        <TableRow
                          key={item.id}
                          className={`home-table-row ${item.IsActive ? '' : 'home-inactive-row'}`}
                          style={{ backgroundColor: item.InputAccepted ? '#d4edda' : '#f8d7da' }}
                        >
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '10%' }}>{formatDate(item.BillDate)}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '10%' }}>{item.BillPrefix}/S/{item.BillNumber}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '40%' }}>{item.ToBranchName}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '15%', textAlign: 'center' }}>{item.GrandTotal}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '15%', textAlign: 'center' }}>{item.TotalQuantity}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '10%', textAlign: 'right' }}>
                            <IconButton className="home-icon-button" component={Link} to={`/StockInDetail/${item.Id}`}>
                              <InfoIcon style={{ fontSize: '20px', color: 'goldenrod' }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                  </Table>
                </TableContainer>
              </div>
            </CardContent>
          </div>
        )}

        {roleName != "Accounts" && (
          <div className="w-full sm:w-4/4 mb-4 ">
            <CardContent className="home-card-content">
              <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black home-productHead flex-grow home-linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>STOCK TRANSFER APPROVAL PENDING</h6>
              </div>

              <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper} className="home-table-container">
                  <Table className="home-table">
                    <TableHead className="home-table-head" sx={{ backgroundColor: '#008080' }}>
                      <TableRow>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '10%' }}>BILL DATE</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '10%' }}>BILL NUMBER</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '40%' }}>TO BRANCH</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '10%', textAlign: 'center' }}>AMOUNT</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', width: '10%', textAlign: 'center' }}>QUANTITY</TableCell>
                        <TableCell className="home-table-head-cell" sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', textAlign: 'center' }}>ACTIONS</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="home-table-body" style={{ backgroundColor: '#9BC1B3' }}>
                      {penstockPendingData.map(item => (
                        <TableRow
                          key={item.id}
                          className={`home-table-row ${item.IsActive ? '' : 'home-inactive-row'}`}
                          style={{ backgroundColor: item.InputAccepted ? '#d4edda' : '#f8d7da' }}
                        >
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '10%' }}>{formatDate(item.BillDate)}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '10%' }}>{item.BillPrefix}/S/{item.BillNumber}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '40%' }}>{item.ToBranchName}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '15%', textAlign: 'center' }}>{item.GrandTotal}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '15%', textAlign: 'center' }}>{item.TotalQuantity}</TableCell>
                          <TableCell className="home-table-cell" sx={{ padding: '2px', width: '10%', textAlign: 'right' }}>
                            <IconButton className="home-icon-button" component={Link} to={`/StockInPending/${item.Id}`} color="primary">
                              <InfoIcon style={{ fontSize: '20px', color: 'goldenrod' }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                  </Table>
                </TableContainer>
              </div>
            </CardContent>
          </div>
        )}
      </div>
      <div className="home-watermark watermark">
        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>
  );
};

export default Home;
